import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Proficiency from './proficiency';
import GrowthAndAchievement from './growth-and-achievement';
import HelpBox from 'components/generic/help/index';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import Analytics from 'utils/analytics';
import RuntimeActions from 'data/app-runtime/actions';

import NormalReadabilityMeasures from './readability-measures';
import NormalMathabilityMeasures from './mathability-measures';

export default CreateReactClass({
    displayName: 'DefaultComparisons',

    propTypes: {
        currentTestEvent: PropTypes.instanceOf(Immutable.Map),
        studentBid: PropTypes.string.isRequired,
        subjectBid: PropTypes.number.isRequired,
        proficienciesToDisplay: PropTypes.instanceOf(Immutable.List),
        statusPercentile: PropTypes.number,
        lexileRange: PropTypes.string,
        comparisonDropdownPeriods: PropTypes.instanceOf(Immutable.Map),
        defaultComparisonPeriodFunction: PropTypes.func,
        selectedComparisonPeriod: PropTypes.instanceOf(Immutable.Map),
        isUserNormData: PropTypes.bool,
    },

    expandFn() {
        Analytics.recordButtonClick(CommonValues.SectionIDs.comparisons, 'expand-module');
        RuntimeActions.expandModule('comparisons', null, true);
    },

    renderExpandButton() {
        return <span key="header-expand-btn" className="icon icon-expand" onClick={this.expandFn} />;
    },

    renderNormalHelpBox(helpText) {
        return (
            <HelpBox
                id={'comparisons-help-box-' + this.props.studentBid}
                appLevelCssClassName="show-normal-comparisons-help-box"
                helpContentsRenderer={helpText}
                helpType="comparisons"
                moduleName={CommonValues.SectionIDs.comparisons}
                helpLabel="comparisons-default-help"
            />
        );
    },

    renderReadabilityMeasures() {
        if (this.props.currentTestEvent && this.props.subjectBid === CommonValues.SUBJECT_BID_READING) {
            return (
                <NormalReadabilityMeasures
                    key="comparisons-normal-readability-measures-module"
                    studentBid={this.props.studentBid}
                    lexileRange={this.props.lexileRange}
                />
            );
        }
        return null;
    },

    renderMathabilityMeasures() {
        if (this.props.currentTestEvent && this.props.subjectBid === CommonValues.SUBJECT_BID_MATHEMATICS) {
            return (
                <NormalMathabilityMeasures
                    key="comparisons-normal-mathability-measures-module"
                    studentBid={this.props.studentBid}
                    quantileRange={this.props.quantileRange}
                />
            );
        }
        return null;
    },

    renderProficiencies() {
        if (this.props.currentTestEvent) {
            return (
                <Proficiency
                    key="comparisons-normal-proficiencies-module"
                    subjectBid={this.props.subjectBid}
                    studentBid={this.props.studentBid}
                    proficienciesToDisplay={this.props.proficienciesToDisplay}
                />
            );
        }
        return null;
    },

    renderNoTestEventText() {
        if (!this.props.currentTestEvent) {
            return (
                <p key="noTestEvents" className="text-no-test-events">
                    {CommonStrings.noTestEvents}
                </p>
            );
        }
        return null;
    },

    renderGrowth() {
        if (this.props.currentTestEvent) {
            return (
                <GrowthAndAchievement
                    key="comparisons-normal-growth-and-achievement-module"
                    subjectBid={this.props.subjectBid}
                    studentBid={this.props.studentBid}
                    comparisonDropdownPeriods={this.props.comparisonDropdownPeriods}
                    defaultComparisonPeriodFunction={this.props.defaultComparisonPeriodFunction}
                    selectedComparisonPeriod={this.props.selectedComparisonPeriod}
                    isUserNormData={this.props.isUserNormData}
                />
            );
        }
        return null;
    },

    helpText() {
        return (
            <div key="comparisons-help-content">
                <div key="initial-text">
                    <p>
                        {CommonStrings.comparisonsHelp.initialText}
                        <span
                            key="help-icon-expanded-icon"
                            className="icon icon-expand help-popup-icon-expand-comparisons"
                        />
                        {CommonStrings.comparisonsHelp.initialTextEnd}
                    </p>
                </div>
            </div>
        );
    },

    render() {
        const expandButton = this.renderExpandButton();
        const normalHelpBox = this.renderNormalHelpBox(this.helpText);
        return (
            <div className="module comparisons" style={{ width: 'calc((100% / 3) - 2.0rem' }}>
                <header>Comparisons</header>
                {expandButton}
                {normalHelpBox}
                {this.renderNoTestEventText()}
                {this.renderGrowth()}
                {this.renderProficiencies()}
                {this.renderReadabilityMeasures()}
                {this.renderMathabilityMeasures()}
            </div>
        );
    },
});
